import React, {useEffect, useState} from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import {FormAddMembership} from "./FormAddMembership";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import AddCustomOfferForm from "../../Orders/add-custom-offer";

export const AddMembership = () => {
    const [isServicesLoading, setIsServicesLoading] = useState(true);
    const [services, setServices] = useState([]);

    const getServices = async () => {
        setIsServicesLoading(true);
        const {response} = await Helper.Get({
            url: api_Routes.MembershipService.ViewAll,
            hasToken: true,
        });
        if (response) {
            setServices(response?.data);
        }
        setIsServicesLoading(false);
    };

    useEffect(() => {
        getServices();
    }, []);
    return (
        <div>
            {" "}
            <PanelHead
                title={
                    <div className="flex items-center justify-between w-full gap-4">
                        <div>Add Membership</div>
                    </div>
                }
            />
            <PanelBody content={<FormAddMembership
                isServicesLoading={isServicesLoading}
                services={services}/>}/>
        </div>
    );
};
